export const AboutFund = ({ amcDetail, fundManagers }) => {
  return (
    <div className=" lil-mt-20">
      <p className="lil-mb-6 lil-mt-12 lil-font-bold lil-text-font-500 lil-text-s-28 sm:lil-text-s-20">
        About {amcDetail.name}
      </p>
      <p className="lil-text-base">{amcDetail.description}</p>
      <table className="lil-border-grey-300 lil-border-separate lil-border-sm lil-border-spacing-0 lil-mt-5 lil-rounded-xl lil-w-full">
        <tr>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5 lil-border-r-sm">
            <p className="lil-text-base lil-text-font-500 lil-font-bold">
              Managers
            </p>
          </td>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5 ">
            {fundManagers.map((ele, i) => (
              <span className="lil-text-font-400 lil-text-s-14 lil-font-medium">
                {ele.name}
                {`${i === fundManagers.length - 1 ? '' : ', '}`}{' '}
              </span>
            ))}
          </td>
        </tr>
        <tr>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5 lil-border-r-sm">
            <p className="lil-text-base lil-text-font-500 lil-font-bold">
              Custodians
            </p>
          </td>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5">
            <p className="lil-text-s-14 lil-text-font-400">
              {amcDetail.custodian}
            </p>
          </td>
        </tr>
        <tr>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5 lil-border-r-sm">
            <p className="lil-text-base lil-text-font-500 lil-font-bold">
              Address
            </p>
          </td>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5">
            <p className="lil-text-s-14 lil-text-font-400">
              {amcDetail.addressLine1} {amcDetail.addressLine2}
            </p>
          </td>
        </tr>
        <tr>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5 lil-border-r-sm">
            <p className="lil-text-base lil-text-font-500 lil-font-bold">
              Fax Nos.
            </p>
          </td>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5">
            <p className="lil-text-s-14 lil-text-font-400">{amcDetail.fax}</p>
          </td>
        </tr>
        <tr>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5 lil-border-r-sm">
            <p className="lil-text-base lil-text-font-500 lil-font-bold">
              Telephone Nos.
            </p>
          </td>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5">
            <p className="lil-text-s-14 lil-text-font-400">{amcDetail.phone}</p>
          </td>
        </tr>
        <tr>
          <td className="lil-p-5 lil-border-grey-300 lil-border-r-sm">
            <p className="lil-text-base lil-text-font-500 lil-font-bold">
              Homepage
            </p>
          </td>
          <td className="lil-p-5">
            <a
              className="lil-text-s-14 lil-btn-link lil-font-medium"
              href={amcDetail.website}
            >
              {amcDetail.website}
            </a>
          </td>
        </tr>
      </table>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/aboutFund.tsx